!function(e,r){"object"==typeof exports&&"object"==typeof module?module.exports=r():"function"==typeof define&&define.amd?define([],r):"object"==typeof exports?exports.storeblocks=r():e.storeblocks=r()}(self,(()=>(()=>{"use strict";var e={279:(e,r,o)=>{o.d(r,{LinkListBase:()=>n});const t=require("styled-components"),n=o.n(t)().ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  padding-inline-start: 0;

  li {
    border-top: 1px solid var(--color-border);

    &:last-child {
      border-bottom: 1px solid var(--color-border);
    }

    & > a {
      display: flex;
      justify-content: space-between;
      align-items: center;

      padding: 16px 0;

      color: var(--color-on-background);
      text-decoration: none;

      &:hover,
      &:focus-visible {
        color: var(--color-primary-variant);
        background: var(--color-overlay-hover-darken);
      }

      &:active {
        color: var(--color-primary-variant);
        background: var(--color-overlay-pressed-darken);
      }

      &[aria-disabled='true'] {
        color: var(--color-disabled);
        pointer-events: none;
      }

      & > i {
        font-size: 24px;
        line-height: 24px;
      }
    }
  }
`}},r={};function o(t){var n=r[t];if(void 0!==n)return n.exports;var l=r[t]={exports:{}};return e[t](l,l.exports,o),l.exports}o.n=e=>{var r=e&&e.__esModule?()=>e.default:()=>e;return o.d(r,{a:r}),r},o.d=(e,r)=>{for(var t in r)o.o(r,t)&&!o.o(e,t)&&Object.defineProperty(e,t,{enumerable:!0,get:r[t]})},o.o=(e,r)=>Object.prototype.hasOwnProperty.call(e,r),o.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var t={};return(()=>{o.r(t),o.d(t,{default:()=>a});const e=require("react");var r=o.n(e);const n=require("@storeblocks/icon");var l=o(279);const a=function(o){var{children:t}=o,a=function(e,r){var o={};for(var t in e)Object.prototype.hasOwnProperty.call(e,t)&&r.indexOf(t)<0&&(o[t]=e[t]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(t=Object.getOwnPropertySymbols(e);n<t.length;n++)r.indexOf(t[n])<0&&Object.prototype.propertyIsEnumerable.call(e,t[n])&&(o[t[n]]=e[t[n]])}return o}(o,["children"]);const i=(0,e.useCallback)((()=>e.Children.map(t,(o=>r().createElement("li",null,(0,e.cloneElement)(o,Object.assign(Object.assign({},o.props),{children:r().createElement(r().Fragment,null,r().createElement("span",null,o.props.children),r().createElement(n.SystemIcon,{name:"arrow-right"}))})))))),[t]);return r().createElement(l.LinkListBase,Object.assign({},a),i())}})(),t})()));
//# sourceMappingURL=index.js.map